type FlowControllerOptions = {
  stepSelector?: string;
  hiddenClass?: string;
  activeClass?: string;
  onFinish?: () => void;
  validateStep?: (index: number, step: HTMLElement) => boolean | Promise<boolean>;
};

export class FlowController {
  private steps: HTMLElement[];
  private currentStep = 0;
  private hiddenClass: string;
  private activeClass: string;
  private onFinish?: () => void;
  private validateStep?: (index: number, step: HTMLElement) => boolean | Promise<boolean>;

  constructor({
    stepSelector = '[data-step]',
    hiddenClass = 'hidden',
    activeClass = 'active',
    onFinish,
    validateStep,
  }: FlowControllerOptions = {}) {
    this.steps = Array.from(document.querySelectorAll(stepSelector)) as HTMLElement[];
    this.hiddenClass = hiddenClass;
    this.activeClass = activeClass;
    this.onFinish = onFinish;
    this.validateStep = validateStep;
  }

  public init() {
    if (!this.steps.length) return;

    this.steps.forEach((step, index) => {
      if (index === 0) {
        step.classList.remove(this.hiddenClass);
        step.classList.add(this.activeClass);
      } else {
        step.classList.remove(this.activeClass);
        step.classList.add(this.hiddenClass);
      }
    });

    this.currentStep = 0;
    this.bindButtons();
  }

  private bindButtons() {
    document.querySelectorAll('[data-action="next"]').forEach((button) => {
      button.addEventListener('click', async (e) => {
        const btn = e.currentTarget as HTMLButtonElement;
        btn.disabled = true; // desabilita botão
        window.scrollTo(0,0);
        await this.next();
        btn.disabled = false; // habilita após a api responder
      });
    });

    document.querySelectorAll('[data-action="back"]').forEach((button) => {
      button.addEventListener('click', () => this.back());
    });

    document.querySelectorAll('[data-action="finish"]').forEach((button) => {
      button.addEventListener('click', () => this.finish());
    });
  }

  public showStep(index: number) {
    if (index < 0 || index >= this.steps.length) return;

    this.steps[this.currentStep].classList.remove(this.activeClass);
    this.steps[this.currentStep].classList.add(this.hiddenClass);

    this.steps[index].classList.remove(this.hiddenClass);
    this.steps[index].classList.add(this.activeClass);

    this.currentStep = index;
  }

  public async next() {
    const current = this.steps[this.currentStep];

    if (this.validateStep) {
      const isValid = await this.validateStep(this.currentStep, current);
      if (!isValid) {
        return; // Se retornou false, interrompe e não avança a página
      }
    }

    if (this.currentStep < this.steps.length - 1) {
      this.showStep(this.currentStep + 1);
    } else {
      this.finish();
    }
  }

  public back() {
    if (this.currentStep > 0) {
      this.showStep(this.currentStep - 1);
    }
  }

  public finish() {
    this.onFinish?.();
  }
}